module.exports = __webpack_public_path__ + "img/gb6172.prt.71bf68f5.jpg";